export const getFormattedTerminalAddress = (terminal?: {
  street?: string;
  postalRegion?: string;
  postalCode?: string;
  country?: string;
}) => {
  const streetValue = terminal?.street || "";
  const cityValue = terminal?.postalRegion ? `, ${terminal?.postalRegion}` : "";
  const postalCodeValue = terminal?.postalCode
    ? ` ${terminal?.postalCode}`
    : "";
  const countryValue = terminal?.country ? `, ${terminal?.country}` : "";

  return `${streetValue}${cityValue}${postalCodeValue}${countryValue}`;
};
